<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	class={classes('w-6 h-6', additionalClass)}
	height="100%"
	width="100%"
	version="1.1"
	viewBox="0 0 50 50"
	fill="currentColor"
	><use xlink:href="#ytp-id-50" />
	<path
		d="M33.6461 37.2111C36.1771 35.5356 37.9055 32.8988 38.4435 29.9181H25.48V20.6761H48.1176C48.3998 22.2811 48.5321 23.9214 48.5321 25.5528C48.5321 32.8547 45.9217 39.0278 41.3801 43.2078"
		stroke="#8F00FF"
	/>
	<path
		d="M12.0139 29.6006C13.9187 35.2798 19.2276 39.5039 25.4888 39.5039C28.7253 39.5039 31.5031 38.675 33.6549 37.2111L41.3889 43.2078C37.4116 46.8764 31.9529 49.0016 25.48 49.0016C16.4056 49.0016 8.10721 43.8868 4.03299 35.7825"
		stroke="#8F00FF"
	/>
	<path
		d="M12.0051 20.4115C10.9998 23.3922 10.9998 26.6199 12.0051 29.6006L4.03301 35.7825C0.62901 29.0009 0.62901 21.0112 4.03301 14.2296"
		stroke="#8F00FF"
	/>
	<path
		d="M25.48 10.4993C28.9016 10.4464 32.2086 11.7339 34.6867 14.0973L41.5388 7.24523C37.2 3.17101 31.4414 0.931068 25.48 1.00162C16.4056 1.00162 8.10721 6.11644 4.03299 14.2296L12.0051 20.4115C13.9011 14.7235 19.2187 10.4993 25.48 10.4993V10.4993Z"
		stroke="#8F00FF"
	/>
</svg>
